export const getPrivacyUrl = (language: string) =>
    `https://www.workist.com${language == 'de' ? '' : '/en'}/privacy-policy`;

export const getImprintUrl = (language: string) => `https://www.workist.com${language == 'de' ? '' : '/en'}/imprint`;

export const getCopyrightUrl = (language: string) => `https://www.workist.com`;

export const getDocsUrl = (language: string | undefined, path: string) =>
    `https://docs.workist.com${language?.startsWith('de') ? '' : '/en'}/docs/${path}`;

export const OUTLOOK_ADD_IN_DOCS_PATH = 'data-exchange/outlook-add-in/';
